<template>
  <b-container>
    <b-card class="shadow atm-rounded my-4">
    <b-row v-for="(user, index) in parentAndChildTitles" :key="index">
      <b-col class="d-flex flex-wrap gap-4 mb-4">
        <b-col class="px-0">
          <b-skeleton :width="user.nameWidth" :height="user.nameHeight"></b-skeleton>
        </b-col>
        <section v-for="option in user.options" :key="option">
          <b-skeleton width="90px" :height="user.nameHeight"></b-skeleton>
        </section>
      </b-col>
    </b-row>
  </b-card>
    <b-row>
      <b-col sm="12" md="6" v-for="section in aditionalSections" :key="section" class="mb-4">
        <b-skeleton width="100%" height="22rem"></b-skeleton>
      </b-col>
    </b-row>
    <section class="d-flex justify-content-center">
      <b-skeleton width="50%" height="3rem"></b-skeleton>
    </section>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      parentAndChildTitles: [
        {
          nameWidth: '10rem',
          nameHeight: '30px',
          options: [0],
        },
        {
          nameWidth: '15rem',
          nameHeight: '20px',
          options: [0, 1],
        },
      ],
      aditionalSections: [0, 1],
    };
  },
};
</script>

<style lang="scss" scoped></style>
